// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_modules_market_market_routes_ts":"ba94dbcccd763629","src_app_modules_user_user_module_ts":"181b147d9be2608c"}[chunkId] + ".js";
};